/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authcallbackunknownerror3Inputs */

const en_authcallbackunknownerror3 = /** @type {(inputs: Authcallbackunknownerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. You can still continue from your case list.`)
};

const pt_authcallbackunknownerror3 = /** @type {(inputs: Authcallbackunknownerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal. Pode continuar a partir da sua lista de casos.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. You can still continue from your case list." |
*
* @param {Authcallbackunknownerror3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authcallbackunknownerror3 = /** @type {((inputs?: Authcallbackunknownerror3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authcallbackunknownerror3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authcallbackunknownerror3(inputs)
	return pt_authcallbackunknownerror3(inputs)
});
export { authcallbackunknownerror3 as "authCallbackUnknownError" }